export default __webpack_public_path__ + "static/media/title-bg.0748f736.svg";